import "./Filmovie.b6f31e6d.js";
import "./Filmovie.134ff114.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8018"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8018"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("64gHy");

var $lq1xk = parcelRequire("lq1xk");

var $bGyN2 = parcelRequire("bGyN2");

var $jqILx = parcelRequire("jqILx");
const $2624aaa516cc6f07$var$buttonWatched = document.querySelector('.btn-watched');
const $2624aaa516cc6f07$var$buttonQueued = document.querySelector('.btn-queued');
const $2624aaa516cc6f07$var$filmsList = document.querySelector('.library-films__list');
let $2624aaa516cc6f07$var$isInitialized = false;
async function $2624aaa516cc6f07$var$handleWatchedClick() {
    $2624aaa516cc6f07$var$buttonWatched?.classList.add('button-library--active');
    $2624aaa516cc6f07$var$buttonQueued?.classList.remove('button-library--active');
    (0, $jqILx.notifications).showLoader();
    try {
        const movies = await (0, $lq1xk.fetchWatchedMovies)((0, $bGyN2.currentLanguage));
        $2624aaa516cc6f07$var$filmsList.innerHTML = (0, $lq1xk.renderMovies)(movies, (0, $bGyN2.currentLanguage));
    } catch (error) {
        (0, $jqILx.notifications).error();
    } finally{
        (0, $jqILx.notifications).hideLoader();
    }
}
async function $2624aaa516cc6f07$var$handleQueuedClick() {
    $2624aaa516cc6f07$var$buttonWatched?.classList.remove('button-library--active');
    $2624aaa516cc6f07$var$buttonQueued?.classList.add('button-library--active');
    (0, $jqILx.notifications).showLoader();
    try {
        const movies = await (0, $lq1xk.fetchQueuedMovies)((0, $bGyN2.currentLanguage));
        $2624aaa516cc6f07$var$filmsList.innerHTML = (0, $lq1xk.renderMovies)(movies, (0, $bGyN2.currentLanguage));
    } catch (error) {
        (0, $jqILx.notifications).error();
    } finally{
        (0, $jqILx.notifications).hideLoader();
    }
}
async function $2624aaa516cc6f07$var$renderActiveTab() {
    if ($2624aaa516cc6f07$var$buttonQueued?.classList.contains('button-library--active')) {
        await $2624aaa516cc6f07$var$handleQueuedClick();
        return;
    }
    await $2624aaa516cc6f07$var$handleWatchedClick();
}
function $2624aaa516cc6f07$export$11e63f7b0f3d9900() {
    if (!$2624aaa516cc6f07$var$isInitialized) {
        $2624aaa516cc6f07$var$buttonWatched?.addEventListener('click', ()=>{
            $2624aaa516cc6f07$var$handleWatchedClick();
        });
        $2624aaa516cc6f07$var$buttonQueued?.addEventListener('click', ()=>{
            $2624aaa516cc6f07$var$handleQueuedClick();
        });
        document.addEventListener('languageChanged', ()=>{
            $2624aaa516cc6f07$var$renderActiveTab();
        });
        $2624aaa516cc6f07$var$isInitialized = true;
    }
    $2624aaa516cc6f07$var$renderActiveTab();
}


async function $742e3ee999dceafa$var$bootstrapLibrary() {
    (0, $2624aaa516cc6f07$export$11e63f7b0f3d9900)();
}
$742e3ee999dceafa$var$bootstrapLibrary();


//# sourceMappingURL=library.10221112.js.map
